import React from "react";
import { IoCheckmark } from "react-icons/io5";

// Kit option card: one choice in a group of big selectable cards (radio behaviour).
// Styles: .inyc-option-card in src/styles/kit-controls.css. Selected = 2px text-colored border, inverted icon, check mark.
const OptionCard = ({ selected = false, icon = null, title, subtitle, onClick, className = "", ...rest }) => (
  <button
    type="button"
    role="radio"
    aria-checked={selected}
    onClick={onClick}
    className={`inyc-option-card ${selected ? "is-selected" : ""} ${className}`.trim()}
    {...rest}
  >
    {icon && (
      <span className="inyc-option-card-icon">
        {React.isValidElement(icon) && icon.props.size == null ? React.cloneElement(icon, { size: 16 }) : icon}
      </span>
    )}
    <span className="inyc-option-card-text">
      <span className="inyc-option-card-title">{title}</span>
      {subtitle && <span className="inyc-option-card-subtitle">{subtitle}</span>}
    </span>
    {selected && (
      <span className="inyc-option-card-check">
        <IoCheckmark size={13} />
      </span>
    )}
  </button>
);

export default OptionCard;
